module.exports = __webpack_public_path__ + "static/bkb-5b5ca5958bb5dc601a5f32248d2a2f73.jpg";